if(typeof _.size === 'undefined') { var e = new Error("Cannot find module '_.size'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = _.size;